import { ButtonTheme, ButtonV2 } from 'builder/components/Button'
import Icon24 from 'builder/components/Icon'
import { useI18n } from 'builder/hooks/useI18n'
import { TRANSLATION_KEY } from '../../constants'
import { ReviewFullSection } from '../../styles'
import banner from './assets/banner.png'
import { Image, Content, Description, TextContainer, Title } from './styles'

type Props = {
  onStartReview?: () => void
} & React.HTMLAttributes<HTMLDivElement>

export const AiResumeReviewWelcomeStep = (props: Props) => {
  const { onStartReview, ...rest } = props
  const { i18n } = useI18n()

  return (
    <ReviewFullSection data-testid="ai-resume-review-welcome-step" {...rest}>
      <Image src={banner} alt="Banner Image" />
      <Content>
        <TextContainer>
          <Title>{i18n.t(`${TRANSLATION_KEY}.welcome_step.title`)}</Title>
          <Description>{i18n.t(`${TRANSLATION_KEY}.welcome_step.description`)}</Description>
        </TextContainer>
        {onStartReview && (
          <ButtonV2
            theme={ButtonTheme.alternative}
            leadingIcon={<Icon24.FeaturedRegular />}
            onClick={onStartReview}
          >
            {i18n.t(`${TRANSLATION_KEY}.welcome_step.start_button_text`)}
          </ButtonV2>
        )}
      </Content>
    </ReviewFullSection>
  )
}
